import jQuery from "jquery";
window.$ = jQuery; // workaround for https://github.com/parcel-bundler/parcel/issues/333
import "bootstrap";
import { debounce } from "instantsearch.js/es/lib/utils";
import instantsearch from "instantsearch.js/es";
import {
  searchBox,
  infiniteHits,
  refinementList,
  stats,
  configure,
} from "instantsearch.js/es/widgets";
import { history } from "instantsearch.js/es/lib/routers";
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
import { SearchClient as TypesenseSearchClient } from "typesense"; // To get the total number of docs

let TYPESENSE_SERVER_CONFIG = {
  apiKey: process.env.TYPESENSE_SEARCH_ONLY_API_KEY,
  nodes: [
    {
      host: process.env.TYPESENSE_HOST,
      port: process.env.TYPESENSE_PORT,
      protocol: process.env.TYPESENSE_PROTOCOL,
    },
  ],
  numRetries: 8,
};

if (process.env[`TYPESENSE_HOST_2`]) {
  TYPESENSE_SERVER_CONFIG.nodes.push({
    host: process.env[`TYPESENSE_HOST_2`],
    port: process.env.TYPESENSE_PORT,
    protocol: process.env.TYPESENSE_PROTOCOL,
  });
}

if (process.env[`TYPESENSE_HOST_3`]) {
  TYPESENSE_SERVER_CONFIG.nodes.push({
    host: process.env[`TYPESENSE_HOST_3`],
    port: process.env.TYPESENSE_PORT,
    protocol: process.env.TYPESENSE_PROTOCOL,
  });
}

if (process.env[`TYPESENSE_HOST_NEAREST`]) {
  TYPESENSE_SERVER_CONFIG["nearestNode"] = {
    host: process.env[`TYPESENSE_HOST_NEAREST`],
    port: process.env.TYPESENSE_PORT,
    protocol: process.env.TYPESENSE_PROTOCOL,
  };
}

const INDEX_NAME = process.env.TYPESENSE_COLLECTION_NAME || "candidate_profiles";
// No keyword index for now because so few profiles for Thryve for now - only prototype
// const KEYWORD_INDEX_NAME = `${INDEX_NAME}_keyword`;
const KEYWORD_INDEX_NAME = INDEX_NAME;

async function getIndexSize() {
  let typesenseSearchClient = new TypesenseSearchClient(
    TYPESENSE_SERVER_CONFIG,
  );
  let results = await typesenseSearchClient
    .collections(INDEX_NAME)
    .documents()
    .search({ q: "*" });

  return results["found"];
}

let indexSize;
(async () => {
  indexSize = await getIndexSize();
})();

let search;

function googleAnalyticsMiddleware() {
  const sendEventDebounced = debounce(() => {
    gtag("event", "page_view", {
      page_location: window.location.pathname + window.location.search,
    });
  }, 3000);

  return {
    onStateChange() {
      sendEventDebounced();
    },
    subscribe() {},
    unsubscribe() {},
  };
}

function renderSearch(searchType) {
  if (search) {
    search.dispose();
  }

  // Use keyword collection for keyword search, main collection for semantic/hybrid
  const collectionName = searchType === "keyword" ? KEYWORD_INDEX_NAME : INDEX_NAME;

  const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: TYPESENSE_SERVER_CONFIG,
    // The following parameters are directly passed to Typesense's search API endpoint.
    //  So you can pass any parameters supported by the search endpoint below.
    //  queryBy is required.
    additionalSearchParameters: {
      query_by:
        searchType === "keyword"
          ? "cleanBrief,personalStatements,name,techStack,skills,jobTitle,company,location,candidateBrief"
          : searchType === "semantic"
          ? "embedding"
          : "cleanBrief,personalStatements,name,techStack,skills,jobTitle,company,location,candidateBrief,embedding",
      exclude_fields: "embedding",
      vector_query: searchType === "keyword" ? null : "embedding:([], k:200)",
      facet_by: "techStack,location,country,experienceLevel,experienceRange,currentIndustry",
      prefix: false,
    },
  });
  const searchClient = typesenseInstantsearchAdapter.searchClient;

  search = instantsearch({
    searchClient,
    indexName: collectionName,
    routing: {
      router: history({
        cleanUrlOnDispose: false,
      }),
    },
    future: {
      preserveSharedStateOnUnmount: true,
    },
    onStateChange({ uiState, setUiState }) {
      const { [collectionName]: state } = uiState;
      const query = state.query || "";
      const page = state.page || 0;
      const searchType = $("#search-type-select").val();

      const configure = {
        ...state.configure,
        typesenseVectorQuery:
          query && ["semantic", "hybrid"].includes(searchType)
            ? `embedding:([], k:200)`
            : null,
      };

      const newUiState = {
        ...uiState,
        [collectionName]: {
          ...state,
          configure,
          page,
        },
      };

      setUiState(newUiState);
    },
  });

  search.addWidgets([
    searchBox({
      container: "#searchbox",
      showSubmit: false,
      showReset: false,
      placeholder:
        "Search for software developers by skills, location, or description",
      autofocus: true,
      cssClasses: {
        input: "form-control",
      },
    }),

    stats({
      container: "#stats",
      cssClasses: {
        text: "text-muted small",
        root: "text-end",
      },
    }),

    infiniteHits({
      container: "#hits",
      cssClasses: {
        list: "list-unstyled grid-container",
        item: "d-flex flex-column search-result-card bg-light-2",
        loadMore: "btn btn-primary mx-auto d-block mt-4",
      },
      templates: {
        item(hit, { html, components }) {
          return html`
            <div class="result-container mb-4 p-3 border rounded position-relative">
              <!-- LinkedIn logo positioned absolutely at top-right -->
              <div class="position-absolute" style="top: 12px; right: 12px;">
                <a 
                  href="${hit.linkedinUrl || '#'}"
                  target="_blank" 
                  class="text-decoration-none"
                  title="${hit.linkedinUrl && hit.linkedinUrl.includes('linkedin.com/in/') ? 'View LinkedIn Profile' : 'Search for this candidate on LinkedIn'}"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="#0077B5" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
              
              <!-- Main content with proper spacing for LinkedIn logo -->
              <div class="d-flex align-items-start mb-3" style="padding-right: 40px;">
                <img 
                  src="${hit.profilePicture && hit.profilePicture.trim() ? hit.profilePicture : `https://www.gravatar.com/avatar/${btoa((hit.name || 'default').replace(/[^\x00-\x7F]/g, '').replace(/[^a-zA-Z0-9]/g, '') || 'default')}?d=identicon&s=60`}" 
                  alt="${hit.name || 'Profile'}" 
                  class="rounded-circle me-3"
                  style="width: 60px; height: 60px; object-fit: cover;"
                />
                <div class="flex-grow-1">
                  <h5 class="mb-1">
                    <a href="${hit.linkedinUrl || '#'}" target="_blank" class="text-decoration-none">
                      ${hit.name ? components.Highlight({ hit, attribute: "name" }) : 'Unknown Profile'}
                    </a>
                  </h5>
                  <p class="text-muted small mb-2">
                    📍 ${hit.location ? components.Highlight({ hit, attribute: "location" }) : 'Location not specified'}
                  </p>
                  <p class="text-muted small mb-2">
                    💼 ${hit.totalYearsExperience || 0} years total experience • ${hit.yearsAtCurrentEmployer || 0} years at current employer
                  </p>
                  ${hit.techStack ? html`<p class="text-muted small mb-2">🛠️ ${components.Highlight({ hit, attribute: "techStack" })}</p>` : ''}
                  ${hit.jobTitle ? html`<p class="text-muted small mb-2">👔 ${components.Highlight({ hit, attribute: "jobTitle" })}</p>` : ''}
                  ${hit.company ? html`<p class="text-muted small mb-2">🏢 ${components.Highlight({ hit, attribute: "company" })}</p>` : ''}
                  <div class="profile-description">
                    ${hit.cleanBrief ? components.Highlight({ hit, attribute: "cleanBrief" }) : (hit.skills ? `Professional with expertise in ${hit.skills.split(', ').slice(0, 6).join(', ')}.` : 'Professional profile available')}
                    ${hit.personalStatements ? html`<br/><br/>${components.Highlight({ hit, attribute: "personalStatements" })}` : ''}
                  </div>
                </div>
              </div>
            </div>
          `;
        },
        empty(results, { html }) {
          if (results.query === "") return null;

          return html`
            <div class="text-center p-4">
              <h4>No profiles found for "${results.query}"</h4>
              <p class="text-muted">Try searching for skills like "React", "Python", or locations like "Berlin", "Munich"</p>
            </div>
          `;
        },
      },
    }),

    refinementList({
      container: "#tech-stack-refinement-list",
      attribute: "techStack",
      searchable: true,
      searchablePlaceholder: "Search tech stack",
      showMore: true,
      limit: 8,
      cssClasses: {
        searchableInput: "form-control form-control-sm mb-2 border-light-2",
        searchableSubmit: "d-none",
        searchableReset: "d-none",
        showMore: "btn btn-primary btn-sm",
        list: "list-unstyled",
        count: "badge rounded-pill text-bg-light fw-normal text-muted ms-2",
        label: "d-flex align-items-center",
        checkbox: "me-2",
      },
    }),

    refinementList({
      container: "#locations-refinement-list",
      attribute: "location",
      searchable: true,
      searchablePlaceholder: "Search locations",
      showMore: true,
      limit: 10,
      cssClasses: {
        searchableInput: "form-control form-control-sm mb-2 border-light-2",
        searchableSubmit: "d-none",
        searchableReset: "d-none",
        showMore: "btn btn-primary btn-sm",
        list: "list-unstyled",
        count: "badge rounded-pill text-bg-light fw-normal text-muted ms-2 mt-0.5",
        label: "d-flex align-items-center",
        checkbox: "me-2",
      },
    }),



    refinementList({
      container: "#experience-range-menu",
      attribute: "experienceLevel",
      limit: 10,
      sortBy: function(a, b) {
        // Define the logical order for experience levels
        const order = [
          "Entry Level",
          "Junior", 
          "Mid",
          "Senior"
        ];
        
        const indexA = order.indexOf(a.name);
        const indexB = order.indexOf(b.name);
        
        // If both values are in our defined order, sort by that order
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        
        // Fallback to alphabetical if not in our defined order
        return a.name.localeCompare(b.name);
      },
      cssClasses: {
        list: "list-unstyled",
        count: "badge rounded-pill text-bg-light fw-normal text-muted ms-2 mt-0.5",
        label: "d-flex align-items-center",
        checkbox: "me-2",
      },
    }),

    refinementList({
      container: "#tenure-range-menu",
      attribute: "experienceRange",
      limit: 10,
      sortBy: function(a, b) {
        // Define the logical order for experience ranges
        const order = [
          "< 1 year",
          "1 year", 
          "2-3 years",
          "4-6 years",
          "7-9 years",
          "10-14 years",
          "15+ years"
        ];
        
        const indexA = order.indexOf(a.name);
        const indexB = order.indexOf(b.name);
        
        // If both values are in our defined order, sort by that order
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        
        // Fallback to alphabetical if not in our defined order
        return a.name.localeCompare(b.name);
      },
      cssClasses: {
        list: "list-unstyled",
        count: "badge rounded-pill text-bg-light fw-normal text-muted ms-2 mt-0.5",
        label: "d-flex align-items-center",
        checkbox: "me-2",
      },
    }),

    configure({
      hitsPerPage: 12,
    }),
  ]);

  search.on("render", function () {
    console.log("Search rendered, hits:", document.querySelectorAll('#hits .result-container').length);
    // Make search terms clickable
    $("#hits .clickable-search-term").on("click", handleSearchTermClick);
    document.querySelectorAll(".ais-Highlight").forEach((element) => {
      element.innerHTML = decodeHtml(element.innerHTML);
    });
  });

  // search.use(googleAnalyticsMiddleware);
  search.start();
}

function handleSearchTermClick(event) {
  const $searchBox = $("#searchbox input[type=search]");
  search.helper.clearRefinements();
  $searchBox.val(event.currentTarget.textContent);
  search.helper.setQuery($searchBox.val()).search();
}

// Source: https://stackoverflow.com/a/42182294/123545
function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

$(function () {
  const $searchBox = $("#searchbox input[type=search]");

  renderSearch($("#search-type-select").val());

  // Handle example search terms
  $(".clickable-search-term").on("click", handleSearchTermClick);
  $("#search-type-select").on("change", function () {
    const searchType = this.value;
    renderSearch(searchType);
  });

  // Clear refinements, when searching
  $searchBox.on("keydown", (event) => {
    search.helper.clearRefinements();
  });

  if (!matchMedia("(min-width: 768px)").matches) {
    $searchBox.on("focus, keydown", () => {
      $("html, body").animate(
        {
          scrollTop: $("#searchbox-container").offset().top,
        },
        500,
      );
    });
  }
});
